import React, { useCallback, useContext } from "react";
import SearchSelect from "../ui-components/SearchSelect";
// import { debounce } from "lodash";
import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import { NotificationsContext } from "../ui-components/Notifications";
import { useIntl } from "react-intl";
import getSystemsOptions from "../utils/getSystemsOptions";

const SelectSystem = ({ value, onChange, disabled }) => {
  const apiRequest = useCountryAxiosInstance();
  const { push } = useContext(NotificationsContext);
  const intl = useIntl();
  // eslint-disable-next-line
  const loadSystemOptions = useCallback(
    async (text, callback) => {
      try {
        const systems = await apiRequest.get(
          `/systems?ciclo=${text}&like=ciclo`
        );
        callback(getSystemsOptions(systems));
      } catch (error) {
        push({
          title: intl.formatMessage({ id: "server_error" }),
          type: "error",
        });
      }
    },
    [push, intl, apiRequest]
  );
  return (
    <SearchSelect
      label="Select system"
      loadOptions={loadSystemOptions}
      value={value}
      onChange={onChange}
      defaultOptions={value ? [{ label: "Remove", value: "" }] : []}
      isDisabled={disabled}
    />
  );
};

export default SelectSystem;
